import { FormControl, FormLabel } from '@chakra-ui/form-control'
import { Text as ChakraText, VStack } from '@chakra-ui/layout'
import { Select } from '@chakra-ui/react'
import type { FormikProps } from 'formik'
import React from 'react'
import { colors } from '../../../../ui-kit'
import { sourceTextMapping, sourceTypeEnum } from '../../../../utils/source'
import type { BackupBucketForm, UserSessionResponse } from '../../../interfaces'
import FreePlanCTA from '../../FreePlan'
import CustomPlanCTA from '../../CustomPlan'
import { FeaturesEnum } from '../../../../utils/features'
import S3BackupForm from './S3BackupForm'

const BackupForm = ({
  typeId,
  form,
  disabled,
}: {
  typeId: number
  form: FormikProps<BackupBucketForm>
  disabled: boolean
}): React.ReactElement | null => {
  switch (typeId) {
    case sourceTypeEnum.AMAZON_S3:
      return <S3BackupForm form={form} disabled={disabled} />

    default:
      return null
  }
}

const BackupBucketSettings = ({
  user,
  form,
  disabled,
}: {
  user: UserSessionResponse | null
  form: FormikProps<BackupBucketForm>
  disabled: boolean
}): React.ReactElement => {
  const { values, handleChange } = form
  return user?.pricingPlan.featuresList.includes(
    FeaturesEnum.MEDIA_LIBRARY_BACKUP,
  ) ? (
    <VStack justifyContent="flex-start" alignItems="flex-start" spacing="2em">
      <FormControl id="typeId" isRequired>
        <FormLabel color={colors.appSlate}>Origin Type</FormLabel>
        <ChakraText marginBottom="1em" color={colors.appSlate}>
          Type of the origin you want to integrate with ImageKit.
        </ChakraText>
        <Select
          name="typeId"
          value={values.typeId}
          onChange={handleChange}
          disabled={disabled}
        >
          {[sourceTypeEnum.AMAZON_S3].map(typeId => (
            <option key={typeId} value={typeId}>
              {sourceTextMapping[typeId]}
            </option>
          ))}
        </Select>
      </FormControl>
      {BackupForm({ typeId: values.typeId, form, disabled })}
    </VStack>
  ) : user?.pricingPlan.isPaidPlan ? (
    <CustomPlanCTA feature={FeaturesEnum.MEDIA_LIBRARY_BACKUP} />
  ) : (
    <FreePlanCTA />
  )
}

export default BackupBucketSettings
